export const SDK_VERSION = '1.0.0';
export const APP_NAME = 'Adaply';

export const DEFAULT_ENDPOINTS = {
  verify: '/api/sdk/editor/verify',
  listModifications: '/api/sdk/editor/modifications',
  saveModificationsBulk: '/api/sdk/editor/modifications/bulk',
  campaignData: '/api/sdk/campaigns/{siteKey}/modifications',
  uploadImage: '/api/sdk/editor/upload-image',
} as const;

export const DEFAULT_CONFIG = {
  debug: false,
  autoApply: true,
  antiFlashTimeoutMs: 1500,
  platformOrigin: (() => {
    if (typeof window === 'undefined') return 'http://localhost';

    const possibleOrigins = [
      (window as any).__CAMPAIGN_PLATFORM_ORIGIN__,
      document.querySelector('meta[name="campaign-platform-origin"]')?.getAttribute('content'),
      document.currentScript?.getAttribute('data-platform-origin'),
      window.location.origin,
    ];

    return possibleOrigins.find((origin) => origin && origin !== 'null') || window.location.origin;
  })(),
} as const;

export const EDITOR_CLASS_PREFIX = 'ce-';
export const RUNTIME_CLASS_PREFIX = '__campaign';

export const CSS_SELECTORS = {
  loadingIndicator: `.${RUNTIME_CLASS_PREFIX}_sdk_loading`,
  timeoutIndicator: `.${RUNTIME_CLASS_PREFIX}_timeout`,
  antiFlashStyle: '[data-campaign-sdk="anti-flash"]',
} as const;

export const MODIFICATION_ACTIONS = ['set_text', 'hide', 'replace_image'] as const;

export const STABLE_DATA_ATTRIBUTES = [
  'data-testid',
  'data-test',
  'data-qa',
  'data-cy',
  'data-track',
  'data-component',
  'data-automation',
] as const;

export const MAX_TEXT_PREVIEW = 5000;
export const MAX_HIGHLIGHTED_ELEMENTS = 6;

export const ERROR_MESSAGES = {
  invalid_token: 'Editor session is invalid. Open editor again from dashboard.',
  expired: 'Editor session expired. Open editor again from dashboard.',
  already_used: 'Editor session was already used. Open editor again from dashboard.',
  site_not_verified: 'This site is not verified in the platform. Verify the site and try again.',
  missing_origin:
    'Browser did not send Origin/Referer. This is usually blocked by privacy settings.',
  invalid_page_url: 'Invalid page URL. Please reopen editor from dashboard.',
  domain_mismatch:
    'Domain mismatch. You are editing a different domain than the session was created for.',
  page_mismatch: 'Page mismatch. Open the editor for the correct page from dashboard.',
  unknown: 'Request failed. Please try again.',
} as const;

export const FATAL_ERRORS = ['invalid_token', 'expired', 'already_used'] as const;
